var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParagraphSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.5H10.75H18.25C19.0797 0.5 19.75 1.17031 19.75 2C19.75 2.82969 19.0797 3.5 18.25 3.5H16.75V20C16.75 20.8297 16.0797 21.5 15.25 21.5C14.4203 21.5 13.75 20.8297 13.75 20V3.5H12.25V20C12.25 20.8297 11.5797 21.5 10.75 21.5C9.92031 21.5 9.25 20.8297 9.25 20V15.5H7.75C3.60625 15.5 0.25 12.1438 0.25 8C0.25 3.85625 3.60625 0.5 7.75 0.5Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphSolid);
export default __webpack_public_path__ + "static/media/paragraph-solid.6f33305c64434ae190ebaf8d122a5dfb.svg";
export { ForwardRef as ReactComponent };